import React, { memo, Suspense } from 'react';
import { Provider } from 'react-redux';
import { SuspenseDebounceLoader } from '@paysera/react-common';
import PropTypes from 'prop-types';

import store from '../store';
import ContactUs from './components/ContactUs';

const ContactFormApp = ({ recipient }) => (
    <Suspense fallback={<SuspenseDebounceLoader />}>
        <Provider store={store}>
            <ContactUs recipient={recipient} />
        </Provider>
    </Suspense>
);

ContactFormApp.propTypes = {
    recipient: PropTypes.string.isRequired,
};

export default memo(ContactFormApp);
